import React from 'react';
import Tags__Intro from '../../../../../generalUI/Tags__Intro';



const TableTags = ({
  value: _value,
//   valuePath,
  formatter,
  colorPresetLookup,
  colorPreset,
  /**
   * if defined, it expects the value to be a string, 
   * which it will then split by the tagsSplitCharacter and pass that 
   * down to Tags__Intro
   */
  tagsSplitCharacter 
}) => {

    const value = tagsSplitCharacter
        ? _value.split(tagsSplitCharacter).map(v => v.trim())
        : _value

    return (
        <Tags__Intro
            key={value}
            value={value}
            // valuePath={valuePath}
            formatter={formatter}
            flexWrap='nowrap'
            XS
            align='left'
            style={{
                justifyContent: "flex-start",
                flexWrap: "nowrap"
            }}
            colorPresetLookup={colorPresetLookup}
            colorPreset={colorPreset}
            />
    )    

    
}

export default TableTags;